import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import React, { memo, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { ErrorToast, SuccessToast, WarningToast } from "../../Components/ToastComponent/RectHotToast";
import Reactportal from "../../Components/Reactportal/Reactportal";
import Input from "../../Components/Input/Input";
import {
  SearchFields,
  createFieldsOfTable,
  GetAllTableKey_Data_Query,
  getFieldsByTableId,
  s,
} from "../../../Utils/AllPagesQuriesAndMutations";
import Button from "../../Components/Button/Button";
import { AiOutlineArrowDown, AiOutlineArrowUp } from "react-icons/ai";
import PortalFooter from "../../Components/Reactportal/PortalFooter";
import "./AddFieldMaster.scss";
import ExpensesListMapComponent from "../SalesBillSetup/LinkSaleExpenses/ExpensesListMapComponent/ExpensesListMapComponent";

const AddFieldMaster = ({ ParentPortalCloseFunction, show }) => {
  const { refetch } = useQuery(getFieldsByTableId, {
    variables: {
      id: "",
    },
  });
  const [createFieldsOfTableFunction, { loading: createFieldDataLoading }] = useMutation(createFieldsOfTable);
  let Form_Key = "Add_Field_Master";

  const [getAllAvailableFields, { data }] = useLazyQuery(SearchFields, {
    fetchPolicy: "network-only",
  });

  const [toggle, settoggle] = useState(show);
  const [availableListToggle, setAvailableListToggle] = useState(true);
  const [selected, setSelected] = useState(-1);
  const [selectedID, setSelectedId] = useState(-1);


  const [remove, setRemove] = useState(-1);
  const FormDataFromRedux = useSelector((store) => store?.FormDataReducer);

  const [invoiceType, setType] = useState("");
  const [SearchValue, setSearchValue] = useState("");
  const [AvailableExpenseList, setAvailableExpenseList] = useState([]);
  const [SelectedField, setSelectedField] = useState([]);

  const FieldsMasterLoading = createFieldDataLoading;

  useEffect(() => {
    if (availableListToggle || SearchValue.length > 2) {
      getAllAvailableFields({
        variables: {
          keyword: SearchValue,
        },
      });
      setAvailableListToggle(false);
    }
  }, [availableListToggle, getAllAvailableFields, SearchValue]);

  useEffect(() => {
    if (data) {
      setAvailableExpenseList(data?.serachFieldMaster);
    }
  }, [data]);

  const Closeformfunction = () => {
    ParentPortalCloseFunction();
    setType("");
    settoggle(false);
  };

  function handleAdd() {
    console.log(SelectedField, selectedID, "selectedield is Already");
    const Checkvalue = SelectedField?.find((el) => selectedID === el?._id)
    if (Checkvalue?._id) {
      return WarningToast("Field is Already Added");
    } else {
      console.log(AvailableExpenseList[selected]);
      let obj = { ...AvailableExpenseList[selected] };
      delete obj.Field_Title;
      setSelectedField([...SelectedField, obj]);
    }
  }

  function RemoveAll() {
    setSelectedField([]);
    setRemove(-1);
  }

  function handleRemove() {
    const filterItem = SelectedField.filter((el, i) => i !== remove);
    setSelectedField(filterItem);
  }

  function HandleUpArrow() {
    if (remove === 0 || remove === -1) {
      setRemove(remove);
    } else {
      setRemove(remove - 1);

      // Create a copy of the SelectedField array
      const newSelectedField = [...SelectedField];

      // Swap the elements in the copied array
      let temp = newSelectedField[remove];
      newSelectedField[remove] = newSelectedField[remove - 1];
      newSelectedField[remove - 1] = temp;

      // Update the state with the new array
      setSelectedField(newSelectedField);
    }
  }

  function HandleDownArrow() {
    if (remove === SelectedField.length - 1 || remove === -1) {
      setRemove(remove);
    } else {
      setRemove(remove + 1);

      // Create a copy of the SelectedField array
      const newSelectedField = [...SelectedField];

      // Swap the elements in the copied array
      let temp = newSelectedField[remove];
      newSelectedField[remove] = newSelectedField[remove + 1];
      newSelectedField[remove + 1] = temp;

      // Update the state with the new array
      setSelectedField(newSelectedField);
    }
  }

  function RemoveData(i) {
    setRemove(i);
  }

  function SelectedData(i, el) {
    setSelected(i);
    setSelectedId(el?._id)
  }

  const submit = async () => {
    let Fields = SelectedField.map((el) => el.Field_Id || el._id);
    await createFieldsOfTableFunction({
      variables: {
        createInput: {
          Field_Id: Fields,
          Table_Id: FormDataFromRedux?.MasterData[Form_Key]?.Table_Key?._id,
        },
      },
    })
      .then(() => {
        SuccessToast("Field Created");
      })
      .catch((err) => {
        ErrorToast(err.message);
      });
  };

  const SaveAndClose = () => {
    submit();
    Closeformfunction();
  };

  const getTableKeyFields = async () => {
    if (FormDataFromRedux?.MasterData[Form_Key]?.Table_Key?._id) {
      refetch({ tableId: FormDataFromRedux?.MasterData[Form_Key]?.Table_Key?._id })
        .then((res) => {
          console.log(res);
          setSelectedField(res.data?.GetTableColumnManagementWithTableKey);
        })
        .catch((error) => {
          setSelectedField([]);
        });
    } else {
      ErrorToast("Select an Invoice Type First");
    }
  };

  return (
    <>
      <div className="LinkSaleMainDiv">
        <Reactportal open={toggle} onClose={Closeformfunction} TypeOfPortal={"Add Fields"} TypeOfId={"Account Id :"}>
          <div className="Link_Field_MainDiv">
            <div className="SelectInvoiceType_div">
              <div className="inpDiv">
                <Input
                  EMTQuery=""
                  checked={""}
                  InputConfig={{
                    masterName: "Table_Master",
                  }}
                  value={invoiceType}
                  type="InputDropForQuery"
                  name="Table_Key"
                  dropdowndata={GetAllTableKey_Data_Query}
                  handleBlur={() => { }}
                  label={"Select Table Key"}
                  modalform={true}
                  Iconinside={true}
                  transactions={true}
                  TypeOfPortal={"Table Key"}
                  handleInputChange={(e) => {
                    // if (e.target.value) {
                    setType(e.target.value);
                    // }
                  }}
                  Tax_Type={true}
                  formkey={Form_Key}
                />
              </div>
              <Button name="getExpenses" text="Get Table Key Fields" action={getTableKeyFields}></Button>
            </div>
            <div className="SearchContainer">
              <Input
                InputConfig={{}}
                value={SearchValue}
                type="text"
                name="Search_Value"
                handleBlur={() => { }}
                label={"Search Field"}
                modalform={true}
                Iconinside={true}
                transactions={true}
                TypeOfPortal={"Table Key"}
                handleInputChange={(e) => {
                  // if (e.target.value) {
                  //   setSearchValue(e.target.value);
                  // }
                  setSearchValue(e.target.value);
                }}
                Tax_Type={true}
                formkey={Form_Key}
              />
            </div>
            <div className="Link_Field_subdiv">
              <ExpensesListMapComponent
                value={AvailableExpenseList}
                name={"Available Fields List"}
                Setfunction={SelectedData}
                HighlightData={AvailableExpenseList[selected]}
              />

              <div className="MiddleDiv">
                <div className="MiddleDiv_subdiv">
                  <Button name="getExpenses1" text="Add" action={handleAdd} />
                  <div className="Arrows_Div">
                    <AiOutlineArrowUp size={30} onClick={HandleUpArrow} />
                    <br />
                    <AiOutlineArrowDown size={30} onClick={HandleDownArrow} />
                  </div>
                  <Button name="getExpenses1" text="Remove" action={handleRemove} />
                  <Button name="getExpenses1" text="Remove All" action={RemoveAll}></Button>
                </div>
              </div>

              <ExpensesListMapComponent
                value={SelectedField}
                name={"Selected Fields"}
                Setfunction={RemoveData}
                HighlightData={remove}
              />
            </div>
            <p className="SelectedField">Selected Fields Count : {SelectedField.length}</p>
          </div>

          <PortalFooter
            renderContent={() => <></>}
            disabled={false}
            submitform={submit}
            SaveAndClose={SaveAndClose}
            handleformclose={() => {
              Closeformfunction();
              settoggle(!toggle);
            }}
            submitType={"Save"}
            loadingState={FieldsMasterLoading}
          />
        </Reactportal>
      </div>
    </>
  );
};

export default memo(AddFieldMaster);
